import { Button } from '@progress/kendo-react-buttons';
import { Label } from '@progress/kendo-react-labels';
import { Col, Row } from 'react-bootstrap';
import { ResendInviteUserAsync } from '../../services/users';
import { appStore } from '../../stores/app-store';
import { useToast } from '../../contexts/toast-context';

type ResendRegistrationProps = {
  buttonText?: string;
  userId?: number;
  organisationId?: number;
  emailConfirmed?: boolean;
};

export const ResendRegistration = ({ ...props }: ResendRegistrationProps) => {
  const { onToastOpen } = useToast();

  const onResendRegistration = async () => {
    appStore.showLoading();
    Promise.all([ResendInviteUserAsync(props.organisationId!, props.userId!)])
      .then((res) => {
        appStore.hideLoading();
        onToastOpen({
          title: 'Resend Registration',
          body: <div>{res}</div>,
          style: 'success'
        });
      })
      .catch((error) => {
        onToastOpen({
          title: 'Resend Registration',
          body: <div>{error}</div>,
          style: 'error'
        });
      });
  };

  return (
    <Row>
      <Col className="d-flex flex-column ">
        {props.emailConfirmed ? (
          <Label>User Registered</Label>
        ) : (
          <>
            <Label>Resend Registration Email</Label>
            <Button
              themeColor={'primary'}
              style={{
                width: 'fit-content'
              }}
              onClick={onResendRegistration}>
              <span>
                {props.buttonText
                  ? props.buttonText
                  : 'Re-Send email invitation'}
              </span>
            </Button>
          </>
        )}
      </Col>
    </Row>
  );
};
